import { css, styled, getFontWeight, useTheme } from '@core-ui/react-stitch';
import { StyledButtonProps } from '../../../types/buttonVariant';
import { getDefaultStyles } from './helpers/getDefaultStyles';
import { getModalStyles } from './helpers/getModalStyles';

const StyledButton = styled.button<StyledButtonProps>(
  ({ theme = useTheme(), isXLarge, variant = 'default', isBRRedesignEnabled }) => {
    const brRedesignStyles = css`
  ${theme.brandFont};
  ${getFontWeight('demiBold')};
  font-size: 12px;
  border: none;
  color: ${theme.color.b2};
  line-height: 14px;
  text-transform: capitalize;
  padding: 0;
  letter-spacing: 0.3px;
`;

    const brandStyles =
      variant !== 'modal'
        ? getDefaultStyles({ theme, isXLarge })
        : getModalStyles({ theme });

    return css`
    ${brandStyles}
    ${isBRRedesignEnabled && brRedesignStyles}
  `;
  }
);

const StyledDiv = styled.div`
  margin-left: auto;
`;

export {
  StyledButton,
  StyledDiv
};
